export const JOB_TYPE = {
  MAILERS: 'Mailers',
  NEWSPAPERS: 'Newspapers',
}
